// Welke kolommen van een matrixvraag horen bij de schaal, en welke vallen erbuiten
// ('Niet van toepassing')?
//
// Nodig omdat twee afnemers dezelfde vraag stelden met elk hun eigen regel: de
// verdeling per antwoord (matrixDistribution.js) en de schuifbalk (vasScale.js).
// Een kolom zonder Position telde in de één als plek 0 (altijd schaal) en in de
// ander naar zijn plek in de lijst, en alleen de schuifbalk brak een gelijke
// Position af op ID (/complete 2026-10-14). Eén regel, hier.
//
// Bij een matrixvraag zijn de KOLOMMEN de schaal; `ReachStart` zegt daar niets
// (150 vragen staan op 0–5 met kolommen 1..5). Kolommen boven `ReachEnd` horen
// er niet bij.
// AI-CONTEXT: See docs/pitfalls.md#database-coarse-sort-key-ties-break-arbitrarily

/**
 * @typedef {object} MatrixColumn
 * @property {string} ID
 * @property {number|string} [Position]
 * @property {string|number} [Title]
 */

/**
 * Kolommen op volgorde van Position; een gelijke Position wordt op ID
 * afgebroken, zodat de volgorde niet van Firestore afhangt.
 *
 * @param {MatrixColumn[]} [columns]
 * @returns {MatrixColumn[]} Een nieuwe, gesorteerde lijst
 */
export const sortMatrixColumns = (columns) => [...(columns || [])].sort((a, b) =>
    ((Number(a.Position) || 0) - (Number(b.Position) || 0)) || String(a.ID).localeCompare(String(b.ID)));

/**
 * @param {MatrixColumn} column
 * @param {number} index - Nulgebaseerde plek in de gesorteerde lijst; telt als
 *   positie (index + 1) voor een kolom zonder Position
 * @param {number|string} [reachEnd] - ReachEnd van de vraag
 * @returns {boolean} true als de kolom bij de schaal hoort
 */
export const isScaleColumn = (column, index, reachEnd) => {
    const end = reachEnd === '' || reachEnd === null || reachEnd === undefined ? NaN : Number(reachEnd);
    if (!Number.isFinite(end)) return true;

    return (Number(column.Position) || index + 1) <= end;
};

/**
 * @param {MatrixColumn[]} [columns] - De MatrixQuestionColumns van de vraag
 * @param {number|string} [reachEnd] - ReachEnd van de vraag
 * @returns {{scale: MatrixColumn[], notApplicable: MatrixColumn[]}} Allebei gesorteerd
 */
const splitMatrixColumns = (columns, reachEnd) => {
    const sorted = sortMatrixColumns(columns);

    return {
        scale: sorted.filter((column, index) => isScaleColumn(column, index, reachEnd)),
        notApplicable: sorted.filter((column, index) => !isScaleColumn(column, index, reachEnd)),
    };
};

export default splitMatrixColumns;
